import React from 'react';
import {
    Row,
    Col,
    Button,
    Container,
    Card,
    Figure,
    Modal,
    FormControl,
    InputGroup,
} from 'react-bootstrap';
import {
    HandThumbsUp,
    HandThumbsDown,
    HandThumbsUpFill,
    HandThumbsDownFill,
    Heart,
    HeartFill,
} from 'react-bootstrap-icons';
import '../../../Styles.css';
import BuildingIcon from '../../../Assets/buildingIcon.png';
import RepairIcon from '../../../Assets/repairIcon.png';
import ExpandIcon from '../../../Assets/expandIcon.png';
import RetroFitIcon from '../../../Assets/plusIcon.png';
import OptimizationIcon from '../../../Assets/optIcon.png';
import Path from '../../Path/Path';
import t from '../../Translations/lang.json';
import axios from 'axios';

const PartnerHome = () => {
    const reaction = React.useRef();
    const filterby = React.useRef();
    const [orders, setOrders] = React.useState([]);
    const [filterBy, setFilterBy] = React.useState('all');
    const [filterOrders, setFilterOrders] = React.useState([]);
    // const [sortBy, setSortBy] = React.useState();
    const [requestId, setRequestId] = React.useState();
    const [customerEmail, setCustomerEmail] = React.useState();
    const [message, setMessage] = React.useState();
    const [partnerEmail, setPartnerEmail] = React.useState();
    const [partnerName, setPartnerName] = React.useState();
    const [partnerContactName, setPartnerContactName] = React.useState();
    const [partnerPhone, setPartnerPhone] = React.useState();
    const [requestTitle, setRequestTitle] = React.useState();
    const [attachment, setAttachment] = React.useState();
    const [errMsg, setErrMsg] = React.useState('No Record Found');
    const [seeMore, setSeeMore] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [showSupport, setShowSupport] = React.useState(false);
    const [fav, setFav] = React.useState([]);
    const [like, setLike] = React.useState([]);
    const [dislike, setDislike] = React.useState([]);
    const [showWarning, setWarning] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(0);
    const [requests, setRequests] = React.useState([]);
    // const attach = React.useRef();
    const handleShowWarning = (item) => {
        setWarning(!showWarning);
        setDeleteItem(item);
    };
    const handleCancel = () => setWarning(!showWarning)
    const handleDelete = () => {
        axios({
            url: Path.basePath + '/delete_request.php?req_id=' + deleteItem,
            method: 'GET',
        })
            .then((response) => {
                if (response.data.success === true) {
                    const temp = requests;
                    const filtered = temp.filter((t) => t.id != deleteItem);
                    setRequests(filtered);

                    setWarning(!showWarning);
                    setDeleteItem(0);
                    // alert('Request was Deleted successfully');
                } else {
                    alert('Failed to delete Request');
                }
		window.location.reload(true);
            })
            .catch((err) => console.log(err));
    };

    const handleContact = (request) => {
        setShow(true);
        setRequestId(request.id);
        setCustomerEmail(request.email);
        setRequestTitle(request.request_title);
        // setPartnerName();
        // setPartnerEmail("jlksdf@fkd.com");
    };

    const handleContactSupport = (request) => {
        setShowSupport(true);
        setRequestId(request.id);
        setCustomerEmail(request.email);
        setRequestTitle(request.request_title);
    };

    const handleFav = (id) => {
        // console.log(fav)
        let arr = [];
        arr = fav;
        let filter = arr.filter((a) => a === id);
        if (filter.length > 0) {
            filter = arr.filter((a) => a != id);
            arr = filter;
        } else {
            arr.push(id);
        }

        setFav([...arr]);
        localStorage.setItem('fav', JSON.stringify(arr));
        checkFav(id);
    };

    const handleLike = (id, evt) => {
        // let likearr = []
        let likearr = like;
        let dislikeArr = dislike;
        let filter = [];
        if (evt == 'like') {
            filter = likearr.filter((l) => l === id);
            if (filter.length > 0) {
                filter = likearr.filter((l) => l != id);
                likearr = filter;
                setLike([...likearr]);
                localStorage.setItem('like', JSON.stringify(likearr));
                checkLike(id);
            } else if (filter.length == 0) {
                likearr.push(id);
                setLike([...likearr]);
                localStorage.setItem('like', JSON.stringify(likearr));
                checkLike(id);
            }
            filter = dislikeArr.filter((d) => d === id);
            if (filter.length > 0) {
                filter = dislikeArr.filter((d) => d != id);
                dislikeArr = filter;
                setDislike([...dislikeArr]);
                localStorage.setItem('dislike', JSON.stringify(dislikeArr));
                checkDisLike(id);
            }
        } else if (evt == 'dislike') {
            filter = dislikeArr.filter((l) => l === id);
            if (filter.length > 0) {
                filter = dislikeArr.filter((l) => l != id);
                dislikeArr = filter;
                setDislike([...dislikeArr]);
                localStorage.setItem('dislike', JSON.stringify(dislikeArr));
                checkDisLike(id);
            } else if (filter.length == 0) {
                dislikeArr.push(id);
                setDislike([...dislikeArr]);
                localStorage.setItem('dislike', JSON.stringify(dislikeArr));
                checkLike(id);
            }
            filter = likearr.filter((d) => d === id);
            if (filter.length > 0) {
                filter = likearr.filter((d) => d != id);
                likearr = filter;
                setLike([...likearr]);
                localStorage.setItem('like', JSON.stringify(likearr));
                checkLike(id);
            }
        }
    };

    const checkFav = (id) => {
        let arr = JSON.parse(localStorage.getItem('fav'));
        if (arr) {
            var filt = arr.filter((f) => f == id);
            if (filt.length > 0) return true;
            else return false;
        }
    };

    const checkLike = (id) => {
        let arr = JSON.parse(localStorage.getItem('like'));
        var filt = arr.filter((f) => f == id);
        if (filt.length > 0) return true;
        else return false;
    };

    const checkDisLike = (id) => {
        let arr = JSON.parse(localStorage.getItem('dislike'));
        var filt = arr.filter((f) => f == id);
        if (filt.length > 0) return true;
        else return false;
    };

    const handleClose = () => setShow(false);
    const handleCloseSupport = () => setShowSupport(false);

    const handleSubmit = () => {
        const data = {
            request_id: requestId,
            request_title: requestTitle,
            customer_email: customerEmail,
            partner_name: partnerName,
            partner_email: partnerEmail,
            partner_contact_name: partnerContactName,
            partner_phone: partnerPhone,
            message: message,
            attachment: attachment,
        };
        axios({
            url: Path.basePath + '/send_contact_mail.php',
            method: 'POST',
            data: JSON.stringify(data),
        }).then((response) => {
            if (response.data.success === true) {
                alert(t[currentLang].emailSentToCustomer);
                setShow(false);
            }
        });
        // console.log(data);
    };
    const handleContactSupportApi = () => {
        const data = {
            name: partnerName,
            email: partnerEmail,
            message: message,
        };
        axios({
            url: Path.basePath + '/contact_support.php',
            method: 'POST',
            data: JSON.stringify(data),
        }).then((response) => {
            if (response.data.success === true) {
                alert('Email Sent');
                setShowSupport(false);
            }
        });
        // console.log(data);
    };
    // const handleShow = () => setShow(true);
    var url = new URL(window.location);
    var lang = url.searchParams.get('language')
        ? url.searchParams.get('language')
        : 'de';
    const currentLang = lang;
    var rights = url.searchParams.get('rights')
        ? url.searchParams.get('rights')
        : 0;
    
    React.useEffect(() => {

        if (localStorage.getItem('fav'))
            setFav(JSON.parse(localStorage.getItem('fav')));
        else localStorage.setItem('fav', '[]');
        if (localStorage.getItem('like'))
            setLike(JSON.parse(localStorage.getItem('like')));
        else localStorage.setItem('like', '[]');
        if (localStorage.getItem('dislike'))
            setDislike(JSON.parse(localStorage.getItem('dislike')));
        else localStorage.setItem('dislike', '[]');
        axios({
            url: Path.basePath + '/partner_auth.php',
            method: 'GET',
        }).then((response) => {
            console.log('data====>', response);
            if (response.data === 1) {
                axios({
                    url: Path.getAllRequests,
                    method: 'GET',
                })
                    .then((response) => {
                        if (response.data.success === true) {
                            if (response.data.data.length > 0) {
				window.parent.postMessage({height: (response.data.data.length)*400}, '*');
				setOrders(response.data.data);
                                setFilterOrders(response.data.data);
                            } else {
                                setErrMsg('No Record Found');
                            }
                        }
                    })
                    .catch((err) => console.log(err));
		{/*
		    if(rights != 2) {
			document.body.style.overflow = "hidden";
		   }
		*/}
            } else {
                setErrMsg('Invalid Credientials Provided');
            }
        });
    }, []);

    const filterTitle = (e) => {
        setFilterOrders([...orders]);
        if (reaction.current.value !== 'none') {
            let sortBy = reaction.current.value;
            var localstorage = JSON.parse(
                localStorage.getItem(reaction.current.value)
            );
            let temp = [...orders];
            if (sortBy != 'none') {
                var filter = temp.filter((t) => {
                    return localstorage.some((f) => {
                        return f === t.id;
                    });
                });
                temp = filter;
            }
            if (filterBy === 'all') {
                var filtered = temp.filter(
                    (t) =>
                        t.request_title
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.service
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.postal_code
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.deadline
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                );
            } else {
                var filtered = temp.filter((t) =>
                    t[filterBy]
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                );
            }
            setFilterOrders([...filtered]);
        } else {
            const temp = [...orders];
            if (filterBy === 'all') {
                var filtered = temp.filter(
                    (t) =>
                        t.request_title
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.service
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.postal_code
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        t.deadline
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                );
            } else {
                var filtered = temp.filter((t) =>
                    t[filterBy]
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                );
            }
            setFilterOrders([...filtered]);
        }
    };

    const handleSort = (event) => {
        const sortBy = event.target.value;
        var localstorage = JSON.parse(localStorage.getItem(sortBy));
        setFilterOrders([...orders]);
        const temp = [...orders];
        if (sortBy != 'none') {
            var filter = temp.filter((t) => {
                return localstorage.some((f) => {
                    return f === t.id;
                });
            });
            setFilterOrders([...filter]);
        }
    };
    return (
        <Container>
            <Row className='d-flex  mt-5 mb-3'>
                <Col xs={12} lg={4}>
                    <h5 className={'custm-title mt-1'}>
                        {t[currentLang].titlePartnerHome}
                    </h5>
                </Col>

                <Col xs={6} lg={3}>
                    <InputGroup>
                        <label className='mt-1 col-12'>
                            {t[currentLang].filterBy}:
                        </label>
                        <select
                            className='form-control ml-1 custom-brder'
                            searchable='Search here..'
                            onChange={handleSort}
                            ref={reaction}
                        >
                            <option value='none' defaultValue="none">
                                {t[currentLang].noneFilter}
                            </option>
                            <option value='fav'>
                                {t[currentLang].favouriteFilter}
                            </option>
                            {/* <option value='like'>liked</option> */}
                            <option value='dislike'>
                                {t[currentLang].dislikedFilter}
                            </option>
                            {/* <option value='created_at'>date(yyyy-mm-dd)</option> */}
                        </select>
                    </InputGroup>
                </Col>

                <Col xs={6} lg={3}>
                    <InputGroup>
                        <label className='mt-1 col-12'>
                            {t[currentLang].searchByFilter}:
                        </label>
                        <select
                            className='form-control ml-1 custom-brder'
                            searchable='Search here..'
                            onChange={(event) => {
                                setFilterBy(event.target.value);
                            }}
                            ref={filterby}
                        >
                            <option value='all' selected>
                                {t[currentLang].allFilter}
                            </option>
                            <option value='request_title'>
                                {t[currentLang].titleFilter}
                            </option>
                            {/* <option value='created_at'>date(yyyy-mm-dd)</option> */}
                            <option value='service'>
                                {t[currentLang].serviceFilter}
                            </option>
                            <option value='postal_code'>
                                {t[currentLang].postalFilter}
                            </option>
                            <option value='deadline'>
                                {t[currentLang].durationFilter}
                            </option>
                        </select>
                    </InputGroup>
                </Col>

                <Col xs={12} lg={2}>
                    <label className='mt-1 col-12'>
                        {/* {t[currentLang].searchByFilter}: */}{' '}
                    </label>
                    <InputGroup className='d-flex mt-2 search-bx'>
                        <div className='form-outline mt-1'>
                            <FormControl
                                type='search'
                                placeholder={t[currentLang].searchTxt}
                                onInput={filterTitle}
                            />
                        </div>
                    </InputGroup>
                </Col>
            </Row>
            {filterOrders.length > 0 ? (
                filterOrders.map((item, index) => (
                    <Row className='mt-3' key={index}>
                        <Col sm={12} lg={12}>
                            <Card className='card'>
                                <Row className='no-gutters'>
                                    <Col xs={12} sm={12} md={8} lg={8}>
                                        <Card.Body>
                                            <Row className='ml-1 mb-2'>
                                                <h4>{item.request_title}</h4>
                                            </Row>
                                            <Row>
                                                <Col
                                                    xs={12}
                                                    sm={12}
                                                    md={4}
                                                    lg={3}
                                                    className='d-flex align-items-center'
                                                >
                                                    <Card className='figure-card'>
                                                        <Card.Body>
                                                            <Figure>
                                                                <Figure.Image
                                                                    width={170}
                                                                    height={10}
                                                                    alt='171x180'
                                                                    src={
                                                                        item.service ==
                                                                        'newbuilding'
                                                                            ? BuildingIcon
                                                                            : item.service ==
                                                                              'expand'
                                                                            ? ExpandIcon
                                                                            : item.service ==
                                                                              'retrofit'
                                                                            ? RetroFitIcon
                                                                            : item.service ==
                                                                              'optimization'
                                                                            ? OptimizationIcon
                                                                            : item.service ==
                                                                              'repair'
                                                                            ? RepairIcon
                                                                            : ''
                                                                    }
                                                                />
                                                                <Figure.Caption className='text-center '>
                                                                    {item.service ==
                                                                    'newbuilding'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .newBuilding
                                                                        : item.service ==
                                                                          'expand'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .expand
                                                                        : item.service ==
                                                                          'retrofit'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .retrofit
                                                                        : item.service ==
                                                                          'optimization'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .optimization
                                                                        : item.service ==
                                                                          'repair'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .repair
                                                                        : ''}
                                                                </Figure.Caption>
                                                            </Figure>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                <Col xs={12} md={8} lg={9}>
                                                    <div className='mb-3'>
                                                        <p>
                                                            {seeMore ===
                                                                false &&
                                                            item.description
                                                                .length > 270
                                                                ? item.description.substring(
                                                                      0,
                                                                      270
                                                                  )
                                                                : item.description}
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#7FA43F',
                                                                    fontWeight: 600,
                                                                }}
                                                                onClick={() =>
                                                                    seeMore ===
                                                                    false
                                                                        ? setSeeMore(
                                                                              true
                                                                          )
                                                                        : setSeeMore(
                                                                              false
                                                                          )
                                                                }
                                                            >
                                                                {seeMore ===
                                                                    false &&
                                                                item.description
                                                                    .length >
                                                                    270
                                                                    ? '... see more'
                                                                    : seeMore ===
                                                                          true &&
                                                                      item
                                                                          .description
                                                                          .length >
                                                                          270
                                                                    ? ' see less'
                                                                    : ''}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0 p-0'>
                                                            {
                                                                t[currentLang]
                                                                    .duration
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.deadline ==
                                                            'timeley'
                                                                ? t[currentLang]
                                                                      .timely
                                                                : item.deadline ==
                                                                  '30days'
                                                                ? t[currentLang]
                                                                      .thirtyDays
                                                                : item.deadline ==
                                                                  '3months'
                                                                ? t[currentLang]
                                                                      .threeMonth
                                                                : item.deadline ==
                                                                  '3or6months'
                                                                ? t[currentLang]
                                                                      .threeSixMonth
                                                                : item.deadline ==
                                                                  'morethan6'
                                                                ? t[currentLang]
                                                                      .morethan6
                                                                : item.deadline}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .postalCode
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.postal_code}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .fullName
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.full_name}
                                                        </p>
                                                    </div>
						    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .requestDate
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.created_at.substr(0,10).split('-').reverse().join(".")}
                                                        </p>
                                                    </div>
						    {(rights == 2) ?
                                                    <div
							className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .contacted
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
							   {item.contacted.split(',').join("\n").substr(1)}
                                                        </p>
                                                    </div>
                                                    :<br/>}
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Col>
                                    <Col
                                        sm={12}
                                        md={4}
                                        lg={4}
                                        className='card-right-sec justify-content-center d-flex flex-direction-column'
                                    >
                                        <Row>
                                            <Col
                                                lg={12}
                                                sm={12}
                                                className='d-flex justify-content-end mt-2'
                                            >
                                                {checkFav(item.id) === true ? (
                                                    <HeartFill
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleFav(item.id)
                                                        }
                                                    />
                                                ) : (
                                                    <Heart
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleFav(item.id)
                                                        }
                                                    />
                                                )}
                                                {/* {checkLike(item.id) === true ? (
                                                    <HandThumbsUpFill
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleLike(
                                                                item.id,
                                                                'like'
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <HandThumbsUp
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleLike(
                                                                item.id,
                                                                'like'
                                                            )
                                                        }
                                                    />
                                                )} */}
                                                {checkDisLike(item.id) ===
                                                true ? (
                                                    <HandThumbsDownFill
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleLike(
                                                                item.id,
                                                                'dislike'
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <HandThumbsDown
                                                        className='m-1 fa-icons'
                                                        onClick={() =>
                                                            handleLike(
                                                                item.id,
                                                                'dislike'
                                                            )
                                                        }
                                                    />
                                                )}
                                                {/* < className="m-1 fa-icons"/> */}
                                            </Col>
                                            {/* </Row> */}
                                            {/* <Row> */}
                                            <Col
                                                lg={12}
                                                sm={12}
                                                className='align-self-end'
                                            >
                                                <Card.Body className='d-flex flex-column justify-content-center'>
                                                    {(rights == 2) ?
						    <button
                                                        // variant='success'
                                                        size='lg'
                                                        className='button rounded mb-2'
                                                        block
                                                        onClick={() => {
                                                            handleShowWarning(
                                                                item.id
                                                            );
                                                        }}
                                                    >
                                                        {
                                                            t[currentLang]
                                                                .deleteRequestBtn
                                                        }
                                                    </button>
						    :<br/>}
                                                    <button
                                                        // variant='success'
                                                        size='lg'
                                                        className='button rounded mb-2'
                                                        block
                                                        onClick={() => {
                                                            handleContact(item);
                                                        }}
                                                    >
                                                        {
                                                            t[currentLang]
                                                                .contactCust
                                                        }
                                                    </button>
                                                    <button
                                                        // variant='success'
                                                        size='lg'
                                                        className='button-outlined rounded'
                                                        block
                                                        onClick={() => {
                                                            handleContactSupport(
                                                                item
                                                            );
                                                        }}
                                                    >
                                                        {
                                                            t[currentLang]
                                                                .contactSupportBtn
                                                        }
                                                    </button>
                                                    {/* <Button
                                                variant='success'
                                                size='lg'
                                                block
                                            >
                                                {t[currentLang].pHomeBtnBid}
                                            </Button> */}
                                                </Card.Body>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                ))
            ) : (
                <Row className='mt-3' key={0}>
                    <Col sm={12} lg={12}>
                        {errMsg && (
                            <Card className='card'>
                                <Row className='no-gutters'>
                                    <Col sm={8} lg={8}>
                                        <Card.Body>
                                            <Row className='ml-1 mb-2'>
                                                <h4>{errMsg}</h4>
                                            </Row>
                                        </Card.Body>
                                    </Col>
                                </Row>
                            </Card>
                        )}
                    </Col>
                </Row>
            )}
            <Modal
                show={show}
                // onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <button
                    style={{
                        backgroundColor: '#7fa43f',
                        width: 30,
                        height: 30,
                        textAlign: 'center',
                        position: 'absolute',
                        top: -12,
                        right: -12,
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 20,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 'none',
                    }}
                    onClick={handleClose}
                >
                    x
                </button>
                <Modal.Body style={{ paddingTop: 30 }}>
                    <Row>
                        <Col lg={6} sm={8}>
                            <FormControl
                                defaultValue={requestTitle}
                                placeholder='Reply to ‚Test Extension‘ [Title] '
                                aria-label='title'
                                className='input-field'
                                disabled
                            />
                        </Col>

                        <Col lg={6} sm={4} className='align-self-center rqt-id'>
                            <h6>
                                {t[currentLang].requestId} # {requestId}
                            </h6>
                        </Col>
                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].fromTxt}
                                aria-label='title'
                                className='input-field mt-2'
                                onChange={(event) =>
                                    // console.log(event.target.value)
                                    setPartnerName(event.target.value)
                                }
                            />
                        </Col>
                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].messageTxt}
                                className='input-field mt-2'
                                as='textarea'
                                rows={8}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </Col>
                        <Col lg={12} sm={12}>
                            <h5>{t[currentLang].partnerContactTxt} </h5>
                        </Col>
                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].emailTxt}
                                aria-label='title'
                                className='input-field'
                                onChange={(event) =>
                                    setPartnerEmail(event.target.value)
                                }
                            />
                        </Col>
                        <Col lg={6} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].ContactNameTxt}
                                aria-label='title'
                                className='input-field mt-2'
                                onChange={(event) =>
                                    setPartnerContactName(event.target.value)
                                }
                            />
                        </Col>
                        <Col lg={6} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].ContactPhoneTxt}
                                aria-label='title'
                                className='input-field mt-2'
                                onChange={(event) =>
                                    setPartnerPhone(event.target.value)
                                }
                            />
                        </Col>
                        {/* <input
                            type='file'
                            ref={attach}
                            onChange={(e) => setAttachment(e.target.files[0])}
                            hidden
                        /> */}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button
                        variant='secondary'
                        onClick={() => attach.current.click()}
                    >
                        Attach File/ offer (??)
                    </Button> */}
                    <Button className='modal-button btn' onClick={handleSubmit}>
                        {t[currentLang].sendEmailBtn}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showSupport}
                onHide={handleCloseSupport}
                backdrop='static'
                keyboard={false}
            >
                <button
                    style={{
                        backgroundColor: '#7fa43f',
                        width: 30,
                        height: 30,
                        textAlign: 'center',
                        position: 'absolute',
                        top: -12,
                        right: -12,
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 20,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 'none',
                    }}
                    onClick={handleCloseSupport}
                >
                    x
                </button>
                <Modal.Body>
                    <Row>
                        <Col lg={6} sm={8}>
                            <FormControl
                                defaultValue={requestTitle}
                                placeholder='Reply to ‚Test Extension‘ [Title] '
                                aria-label='title'
                                className='input-field'
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={4} className='align-self-center'>
                            <h6>{t[currentLang].requestId} #{requestId}</h6>
                        </Col>
                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].fromTxt}
                                aria-label='title'
                                className='input-field mt-2'
                                onChange={(event) =>
                                    // console.log(event.target.value)
                                    setPartnerName(event.target.value)
                                }
                            />
                        </Col>

                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].messageTxt}
                                className='input-field mt-2'
                                as='textarea'
                                rows={8}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className='modal-button btn'
                        onClick={handleContactSupportApi}
                    >
                        {t[currentLang].sendQuery}
                    </Button>
                </Modal.Footer>
            </Modal>
	    <Modal
                show={showWarning}
                onHide={handleCancel}
                backdrop='static'
                keyboard={false}
            >
                {/* <button
                    style={{
                        backgroundColor: '#7fa43f',
                        width: 30,
                        height: 30,
                        textAlign: 'center',
                        position: 'absolute',
                        top: -12,
                        right: -12,
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 20,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 'none',
                    }}
                    onClick={handleCancel}
                >
                    x
                </button> */}
                <Modal.Body style={{ paddingTop: 30 }}>
                    <Row>
                        <Col
                            lg={12}
                            sm={12}
                            style={{ paddingTop: 20, paddingBottom: 20 }}
                        >
                            {t[currentLang].warningTxt}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='modal-button btn' onClick={handleDelete}>
                        {t[currentLang].delete}
                    </Button>
                    <Button
                        variant='contained'
                        className='btn'
                        onClick={handleCancel}
                    >
                        {t[currentLang].cancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};
export default PartnerHome;
